// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface JobId
 */
export interface JobId {}

/**
 * Check if a given object implements the JobId interface.
 */
export function instanceOfJobId(value: object): value is JobId {
  return true;
}

export function JobIdFromJSON(json: any): JobId {
  return JobIdFromJSONTyped(json, false);
}

export function JobIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobId {
  return json;
}

export function JobIdToJSON(json: any): JobId {
  return JobIdToJSONTyped(json, false);
}

export function JobIdToJSONTyped(value?: JobId | null, ignoreDiscriminator: boolean = false): any {
  return value;
}
